import React, { lazy } from 'react';

// Login and the root redirect stay eager: a cold visitor hits them, so lazy
// would add a round trip before first paint. Everything else is split.
import RedirectPage from './UI/Pages/RedirectPage/redirect.page';
import Login from './UI/Pages/Login/login.page';

const SSOCallback = lazy(() => import(/* webpackChunkName: "sso-callback" */ './UI/Pages/SSOCallback/ssocallback.page'));
const SetUpAccount = lazy(() => import(/* webpackChunkName: "set-up-account" */ './UI/Pages/SetUpAccount/setUpAccount'));
const VerifyCode = lazy(() => import(/* webpackChunkName: "verify-code" */ './UI/Pages/VerifyCode/verifyCode.page'));
const ForgotPassword = lazy(() => import(/* webpackChunkName: "forgot-password" */ './UI/Pages/ForgotPassword/forgotPassword'));
const ResetPassword = lazy(() => import(/* webpackChunkName: "reset-password" */ './UI/Pages/ResetPassword/resetPassword'));
const ForcePasswordChange = lazy(() => import(/* webpackChunkName: "force-password-change" */ './UI/Pages/ForcePasswordChange/forcePasswordChange'));
const TestPage = lazy(() => import(/* webpackChunkName: "test" */ './UI/Pages/TestPage/test'));
const GoogleTwoFactorPage = lazy(() => import(/* webpackChunkName: "google-2fa" */ './UI/Pages/GoogleTwoFactor/google-twofactor.page'));

const publicPages = [
  {
    path: '/',
    element: <RedirectPage />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/test',
    element: <TestPage />,
  },
  {
    path: '/callback',
    element: <SSOCallback />
  },
  {
    path: '/google-2fa',
    element: <GoogleTwoFactorPage />
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
  {
    path: '/force-password-change',
    element: <ForcePasswordChange />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/set-up-account',
    element: <SetUpAccount />,
  },
  {
    path: '/activate',
    element: <VerifyCode />,
  },
];

export default publicPages;
